export class WaitKeys {
    public static readonly login = "global.login";

    public static readonly baseData = "global.baseData";
}
